module.exports = __webpack_public_path__ + "static/media/ps_logo_white.871e548d.png";